import { useEffect, useRef } from 'react'

import Spinner from '@components/Spinner'
import { useAuthContext } from '@modules/auth/hooks/useAuthContext'
import { useQuery } from '@tanstack/react-query'

import settingsApi from './api'

const SettingsPage = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  const { user } = useAuthContext()

  const { isLoading } = useQuery({
    queryKey: [settingsApi.getPersonEventId.key, user?.id],
    queryFn: () => settingsApi.getPersonEventId.fn(user!.id),
    enabled: !!user,
  })

  useEffect(() => {
    if (!iframeRef.current) {
      return
    }

    const handleIframeLoad = () => {
      if (!iframeRef.current) {
        return
      }

      const iframeDocument = iframeRef.current.contentDocument

      if (iframeDocument) {
        const elementsToDeleteSelectors = ['.cookies-popup', '.header', '.left-menu', '.layout-footer']

        const observer = new MutationObserver(() => {
          const elementsToDelete = elementsToDeleteSelectors
            .map(selector => iframeDocument.querySelector(selector))
            .filter(Boolean) as Element[]

          elementsToDelete.forEach(element => element.remove())
        })

        observer.observe(iframeDocument, { childList: true, subtree: true })
      }
    }

    iframeRef.current.addEventListener('load', handleIframeLoad)

    // eslint-disable-next-line consistent-return
    return () => {
      if (!iframeRef.current) {
        return
      }

      iframeRef.current.removeEventListener('load', handleIframeLoad)
    }
  }, [isLoading])

  if (isLoading) {
    return <Spinner centered />
  }

  return <iframe ref={iframeRef} title="settings" src="/settings" style={{ border: 'none', width: '100%' }} />
}

export default SettingsPage
